export const replaceContentPlaceholders = (
  content: string,
  values: {
    currencyApplicationClassPrice?: string;
    currencyApplicationAdditionalClassPrice?: string;
    currencySearchClassPrice?: string;
    currencySearchAdditionalClassPrice?: string;
    finalFeesFirstClass?: string;
    finalFeesAdditionalClass?: string;
    estimatedProcessingMonths?: string;
    yearsOfValidity?: string;
    requiredDocuments?: string;
    publicPriceNotes?: string;
    average?: number;
    numberOfReviews?: number;
    bestRating?: number;
  }
) => {
  let replacedContent = content;

  if (
    content.includes('{{registrationFirstClassPrice}}') &&
    values.currencyApplicationClassPrice
  ) {
    replacedContent = replacedContent.replace(
      '{{registrationFirstClassPrice}}',
      values.currencyApplicationClassPrice
    );
  }
  if (
    content.includes('{{searchFirstClassPrice}}') &&
    values.currencySearchClassPrice
  ) {
    replacedContent = replacedContent.replace(
      '{{searchFirstClassPrice}}',
      values.currencySearchClassPrice
    );
  }
  if (
    content.includes('{{registrationAdditionalClassPrice}}') &&
    values.currencyApplicationAdditionalClassPrice
  ) {
    replacedContent = replacedContent.replace(
      '{{registrationAdditionalClassPrice}}',
      values.currencyApplicationAdditionalClassPrice
    );
  }
  if (
    content.includes('{{searchAdditionalClassPrice}}') &&
    values.currencySearchAdditionalClassPrice
  ) {
    replacedContent = replacedContent.replace(
      '{{searchAdditionalClassPrice}}',
      values.currencySearchAdditionalClassPrice
    );
  }
  if (
    content.includes('{{finalFeesFirstClass}}') &&
    values.finalFeesFirstClass
  ) {
    replacedContent = replacedContent.replace(
      '{{finalFeesFirstClass}}',
      values.finalFeesFirstClass
    );
  }
  if (
    content.includes('{{finalFeesAdditionalClass}}') &&
    values.finalFeesAdditionalClass
  ) {
    replacedContent = replacedContent.replace(
      '{{finalFeesAdditionalClass}}',
      values.finalFeesAdditionalClass
    );
  }
  if (
    content.includes('{{estimatedProcessingMonths}}') &&
    values.estimatedProcessingMonths
  ) {
    replacedContent = replacedContent.replace(
      '{{estimatedProcessingMonths}}',
      values.estimatedProcessingMonths
    );
  }
  if (content.includes('{{yearsOfValidity}}') && values.yearsOfValidity) {
    replacedContent = replacedContent.replace(
      '{{yearsOfValidity}}',
      values.yearsOfValidity
    );
  }
  if (content.includes('{{requiredDocuments}}') && values.requiredDocuments) {
    replacedContent = replacedContent.replace(
      '{{requiredDocuments}}',
      values.requiredDocuments
    );
  }
  if (content.includes('{{publicPriceNotes}}') && values.publicPriceNotes) {
    replacedContent = replacedContent.replace(
      '{{publicPriceNotes}}',
      values.publicPriceNotes
    );
  }

  if (content.includes('{{average}}') && values.average !== undefined) {
    replacedContent = replacedContent.replace(
      '{{average}}',
      values.average.toString()
    );
  }
  if (
    content.includes('{{numberOfReviews}}') &&
    values.numberOfReviews !== undefined
  ) {
    replacedContent = replacedContent.replace(
      '{{numberOfReviews}}',
      values.numberOfReviews.toString()
    );
  }
  if (content.includes('{{bestRating}}') && values.bestRating !== undefined) {
    replacedContent = replacedContent.replace(
      '{{bestRating}}',
      values.bestRating.toString()
    );
  }

  return replacedContent;
};
